import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

interface FolderBreadcrumbProps {
  currentFolder?: {
    id: string;
    name: string;
  } | null;
  onNavigateToRoot: () => void;
}

export const FolderBreadcrumb: React.FC<FolderBreadcrumbProps> = ({
  currentFolder,
  onNavigateToRoot,
}) => {
  if (!currentFolder) {
    return (
      <div className="flex items-center gap-2 mb-4">
        <Home className="w-4 h-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-700">All Folders</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4 mb-4">
      <Button
        variant="ghost"
        size="sm"
        onClick={onNavigateToRoot}
        className="flex items-center gap-2 text-blue-600 hover:text-blue-700"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Folders
      </Button>

      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onNavigateToRoot();
              }}
              className="flex items-center gap-1"
            >
              <Home className="w-3 h-3" />
              All Folders
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{currentFolder.name}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};
